import {Card, RelativeDateRenderer} from '@code-like-a-carpenter/components';
import type {PropsWithChildren} from 'react';
import {Fragment} from 'react';

export interface ChangelogItemProps {
  title: string;
  date: Date;
  /** here for mocking storybook. Probably not production appropriate */
  fromDate?: Date;
}

export const ChangelogItem = ({
  children,
  date,
  fromDate,
  title,
}: PropsWithChildren<ChangelogItemProps>) => (
  <Fragment>
    <Card
      className="mt-4 mb-4"
      headerSlot={title}
      subtitleSlot={
        <RelativeDateRenderer referenceDate={fromDate} value={date} />
      }
    >
      {children}
    </Card>
  </Fragment>
);
